import SectorService from '../services/Sector.js';
import BenefitService from '../services/Benefit.js';
import DevelopmentStageService from '../services/DevelopmentStage.js';
import GeographicalAreaService from '../services/GeographicalArea.js';
import CountryService from '../services/Country.js';
import PatentStatusService from '../services/PatentStatus.js';
import CompanyTypeService from '../services/CompanyTypes.js';
import InvestmentTypeService from '../services/InvestmentTypes.js';
import CurrencyService from '../services/Currencies.js';
import LibraryGroupService from '../services/LibraryGroup.js';
import Helper from '../Helper.js';
import Paginate from 'vuejs-paginate';
import Multiselect from 'vue-multiselect';
import EditorJquery from '../innovation/editor/EditorJquery.js';

if($('#dashboard--innovation-library').length){
    var app = new Vue({
        el: '#dashboard--innovation-library',
        data: {
            libraryGroups:[],
            sectors:[],
            countries:[],
            developmentStages:[],
            benefits:[],
            patentStatuses:[],
            geographicalAreas:[],
            companyTypes:[],
            investmentTypes:[],
            currencies:[],
            loading: true,
            firstLoad:true,
            showGroup: false,
            Helper: Helper,
            LibraryGroupService: LibraryGroupService,
            group: {},
            limit: limit,
            showManageUsers: false,
            newUserEmail: '',
            loadingMessage: '',
            pagination: [],
            show: 0
        },
        methods: {
            managePermission() {
                axios.get('/api/v1/library-group/manage-permission').then((response) => {
                    this.show = response.data;
                }).catch(error => {
                    this.errorHandler(error);
                });
            },
            paginate(page) {
                this.get(page);
            },
            get(page = 1){
                this.loading = true; 
                axios.get('/api/v1/library-group?page=' + page).then((response) =>  {
                    this.libraryGroups = response.data.data;
                    this.pagination = response.data;
                    this.managePermission();
                    this.loading = false;
                }).catch(error => {
                    this.errorHandler(error);
                    this.loading = false; 
                });
            },
            addEdit(group){
                EditorJquery.jqueryHelpers();
                if(group){
                    this.group = JSON.parse(JSON.stringify(group));
                }else{
                    this.group = {
                        sector_id : null,
                        patent_status_id : null,
                        geographical_area_id : null,
                        benefit_id: null,
                        development_stage_id : null,
                        company_type_id : null,
                        investment_type_id : null,
                        currency_id: null,
                        search: null,
                        name: null,
                        keywords: [],
                        search_keywords: []
                    };
                }
                this.showGroup = true;
            },
            save(){

                if(!this.group.name){
                    this.$toasted.error('The group must have a name');
                    return;
                }

                this.group.country_ids_only = this.group.countries;
                if (this.group.countries && this.group.countries.length > 0) {
                    this.group.country_ids_only = this.group.countries.map(function (a) {
                        if (a.id !== undefined) {
                            return a.id;
                        }
                    });
                }

                this.group.sector_ids_only = this.group.sectors;
                if (this.group.sectors && this.group.sectors.length > 0) {
                    this.group.sector_ids_only = this.group.sectors.map(function (a) {
                        if (a.id !== undefined) {
                            return a.id;
                        }
                    });
                }

                this.group.benefit_ids_only = this.group.benefits;
                if (this.group.benefits && this.group.benefits.length > 0) {
                    this.group.benefit_ids_only = this.group.benefits.map(function (a) {
                        if (a.id !== undefined) {
                            return a.id;
                        }
                    });
                }

                this.group.development_ids_only = this.group.development_stages;
                if (this.group.development_stages && this.group.development_stages.length > 0) {
                    this.group.development_ids_only = this.group.development_stages.map(function (a) {
                        if (a.id !== undefined) {
                            return a.id;
                        }
                    });
                }

                this.group.patent_ids_only = this.group.patent_statuses;
                if (this.group.patent_statuses && this.group.patent_statuses.length > 0) {
                    this.group.patent_ids_only = this.group.patent_statuses.map(function (a) {
                        if (a.id !== undefined) {
                            return a.id;
                        }
                    });
                }

                this.group.investment_ids_only = this.group.investment_types;
                if (this.group.investment_types && this.group.investment_types.length > 0) {
                    this.group.investment_ids_only = this.group.investment_types.map(function (a) {
                        if (a.id !== undefined) {
                            return a.id;
                        }
                    });
                }

                this.group.company_ids_only = this.group.company_types;
                if (this.group.company_types && this.group.company_types.length > 0) {
                    this.group.company_ids_only = this.group.company_types.map(function (a) {
                        if (a.id !== undefined) {
                            return a.id;
                        }
                    });
                }

                // if ($('.s-tag-data').val() !== undefined && $('.s-tag-data').val() !== '') {
                //     this.group.search_keywords = [];
                //     let searchTagsData = JSON.parse($('.s-tag-data').val());
                //     searchTagsData.forEach(element => this.group.search_keywords.push(element.tag))
                // } else if (this.group.search_keywords && this.group.search_keywords.length > 0) {
                //     this.group.search_keywords = this.group.search_keywords.map(keyword => keyword.word);
                // }

                // popup used.
                // Just grab the tags directly until we get rid of materializecss - Jon
                var _tags = [];
                $('.s-chips-initial').children('.chip').each(function(i) { 
                    var text = $(this).clone().children().remove().end().text()
                    _tags.push(text); // because theres a child element beside the text we want
                });
                this.group.search_keywords = _tags;

                if ((this.group.sector_ids_only === undefined || this.group.sector_ids_only.length === 0) &&
                    (this.group.country_ids_only === undefined || this.group.country_ids_only.length === 0) &&
                    (this.group.benefit_ids_only === undefined || this.group.benefit_ids_only.length === 0) &&
                    (this.group.development_ids_only === undefined || this.group.development_ids_only.length === 0) &&
                    (this.group.patent_ids_only === undefined || this.group.patent_ids_only.length === 0) &&
                    (this.group.investment_ids_only === undefined || this.group.investment_ids_only.length === 0) &&
                    (this.group.company_ids_only === undefined || this.group.company_ids_only.length === 0) &&
                    this.group.search_keywords.length === 0) {
                    this.$toasted.error('The group must have a category or keyword');
                    return;
                }

                this.loading = true;

                // if ($('.tag-data').val() !== undefined && $('.tag-data').val() !== '') {
                //     this.group.keywords = [];
                //     let tagsData = JSON.parse($('.tag-data').val());
                //     tagsData.forEach(element => this.group.keywords.push(element.tag))
                // } else if (this.group.keywords && this.group.keywords.length > 0) {
                //     this.group.keywords = this.group.keywords.map(keyword => keyword.word);
                // }

                // Just grab the tags directly until we get rid of materializecss - Jon
                var _tags2 = [];
                $('.chips-initial').children('.chip').each(function(i) { 
                    var text = $(this).clone().children().remove().end().text()
                    _tags2.push(text); // because theres a child element beside the text we want
                });
                this.group.keywords = _tags2;


                if(this.group.slug){
                    axios.patch('/api/v1/library-group/'+this.group.slug, this.group).then(() =>  {
                        this.get();
                        this.showGroup = false;
                        this.$toasted.success('Group Saved');
                    }).catch(error => {
                        this.errorHandler(error);
                        this.loading = false;
                    });
                }else{
                    axios.post('/api/v1/library-group', this.group).then(() =>  {
                        this.get();
                        this.showGroup = false;
                        this.$toasted.success('Group Added');
                    }).catch(error => {
                        this.errorHandler(error);
                        this.loading = false;
                    });
                }
            },
            deleteGroup(slug){
                if(confirm("Are you sure you want to delete this library group? Removing your group will also delete all your favourites from this group.")){
                    this.loading = true; 
                    axios.delete('/api/v1/library-group/'+slug)
                    .then(() =>  {
                        this.get();
                        this.$toasted.success('Library group deleted');
                    }).catch((error) => {
                        this.errorHandler(error);
                        this.loading = false;
                    });
                }
            },
            favorite(e, innovation, slug, Helper){
                e.stopPropagation();
                axios.get('/api/v1/library-group/'+slug+'/favorite/'+innovation.id).then(() =>  {
                    innovation.isFavorite = innovation.isFavorite ? false : true;
                    this.$toasted.success('Innovation Favorited');
                }).catch(error => {
                    this.errorHandler(error);
                });
            },
            ownedGroups(){
                var count = this.libraryGroups.filter(function(obj) {
                    return obj.isOwner;
                });
                return count.length;
            },
            errorHandler(error){
                console.log(error.response);
                if(error.response && typeof error.response.data === 'string'){
                    this.$toasted.error(error.response.data);
                }else if(error.response){
                    this.$toasted.error(error.response.data.message);
                }
            },
            manageUsersModal(group) {
                this.group = JSON.parse(JSON.stringify(group));
                this.showManageUsers = true;
            },
            manageUsers() {
                this.loading = true;
                this.group.collaboratorIds = this.getCollaboratorIds();
                axios.post('/api/v1/library-group/' + this.group.slug + '/manage-users', {'group': this.group}
                ).then((response) => {
                    this.get();
                    this.showManageUsers = false;
                    this.$toasted.success('Users Updated');
                }).catch(error => {
                    this.errorHandler(error);
                    this.loading = false;
                });
            },
            getCollaboratorIds(){
                return this.group.collaborators.map(user => user.id);
            },
            addCollaborator(){
                if(!this.newUserEmail){
                    this.$toasted.error('Please add an email address');
                    return;
                }

                this.loading = true;
                this.loadingMessage = 'Looking for User';

                axios.post('/api/v1/find-user', {
                    'email':this.newUserEmail,
                    'type': 'library',
                    'type_id': this.group.id ? this.group.id : null
                })
                    .then((response) =>  {
                        if (response.data === 'New user') {
                            if (!this.group.hasOwnProperty('invited')) {
                                this.group.invited = [];
                            }
                            this.group.invited.push(this.newUserEmail);
                            this.newUserEmail = '';
                            this.$toasted.success('User added, please save to apply changes');
                        } else {
                            let newUser = response.data;

                            let existingUser = this.group.collaborators.filter(user => {
                                return user.id === newUser.id;
                            });

                            this.newUserEmail = '';

                            if (!existingUser.length) {
                                this.group.collaborators.push(newUser);
                                this.$toasted.success('User added, please save to apply changes');
                            } else {
                                this.$toasted.error('This user has already been added');
                            }
                        }

                        this.$nextTick(function () {
                            this.loading = false;
                        });

                    })
                    .catch((error) =>  {
                        this.$toasted.error(error.response.data);
                        this.loading = false;
                    });
            },
            removeUser(index){
                this.group.collaborators.splice(index, 1);
            },
            removeInvitedUser(index){
                this.group.invited.splice(index, 1);
            },
            setCountries(countries) {
                let name = '';
                countries.forEach((country) => {
                    if (name) {
                        name += ', '
                    }
                    name += country.name
                });
                return name
            },
            setKeywords(keywords) {
                let keys = '';
                keywords.forEach((keyword) => {
                    if (keys) {
                        keys += ', '
                    }
                    keys += keyword.word
                });
                return keys
            },
            setData(data) {
                let name = '';
                data.forEach((datum) => {
                    if (name) {
                        name += ', '
                    }
                    name += datum.name
                });
                return name
            }
        },
        mounted(){
            SectorService.getSectors().then(data => {
                this.sectors = data;
            });
            BenefitService.getBenefits().then(data => {
                this.benefits = data;
            });
            CountryService.getCountries('libraries').then(data => {
                this.countries = data;
            });
            DevelopmentStageService.getDevelopmentStages().then(data => {
                this.developmentStages = data;
            });
            PatentStatusService.getPatentStatuses().then(data => {
                this.patentStatuses = data;
            });
            GeographicalAreaService.getGeographicalAreas().then(data => {
                this.geographicalAreas = data;
            });
            CompanyTypeService.getCompanyTypes().then(data => {
                this.companyTypes = data;
            });
            InvestmentTypeService.getInvestmentTypes().then(data => {
                this.investmentTypes = data;
            });
            CurrencyService.getCurrencies().then(data => {
                this.currencies = data;
            });

            this.get();
        },
        components: {
            'paginate': Paginate,
            'multiselect': Multiselect
        },
    });
}